"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractAccount = exports.getBrandingBasedOnMultipleFulfillerNames = exports.getBrandingBasedOnFulfillerName = exports.getBranding = void 0;
const jwt_decode_1 = __importDefault(require("jwt-decode"));
const WIRmachenDRUCK_1 = require("./brands/WIRmachenDRUCK");
const Cimpress_1 = require("./brands/Cimpress");
function extractAccount(accessToken) {
    const decoded = (0, jwt_decode_1.default)(accessToken);
    return decoded['https://claims.cimpress.io/account'];
}
exports.extractAccount = extractAccount;
function getBranding(accessToken) {
    const accountId = extractAccount(accessToken);
    switch (accountId) {
        case 'kjEeD7THrCpbHqyd3pMUVk': // WIRmachenDRUCK-575-mmtgxcmt1x
        case '2jAZGJ4xUKPCqXiekuik2e': // WIRmachenDRUCK-570-jxd261d3f1
        case 'vdUjehjatkr9pFYa4vwdqq': // WIRmachenDRUCK-414-wh9555fejp
        case '83zGGmsjgYBb7oi9NCdpy': // WIRmachenDRUCK-480-et7bxb14kd
        case 'pUejQ785SwDqWYsJrX3Bvb': // WIRmachenDRUCK-571-xjy3k2r5n3
        case '663zQoD6TszZGgDYTrpNVn': // WIRmachenDRUCK-576-ajwjyjtfnh
        case 'pPQJdKNtwPrsayNSoD6Zn9': // WIRmachenDRUCK-581-xwa3rrawj5
        case '5zyaV6vhP7ssMUxrTpAqXC': // WIRmachenDRUCK-860-hdr0wawjb5
        case 'p9h7ZCQf4m5AEeWDGq8zFT': // WIRmachenDRUCK
        case 'rSBVzvSD7qSed2FmuJNgh2': // WIRmachenDRUCK Mumbai-based Graphics Service Org
        case 'bGXrsXJUao1w88rLQjMRZz': // WMD-940
        case '87yqR87czG8MngjXdpUmZZ': // WirmachenDruck-123-x4v1p1t3va
        case 'gdiF5BXNP8k89F7kMHC3i5': // WirmachenDruck-395
        case 'gg6vypPm7PuraPF91FKy7Y': // wirmachendruck-demoPOM-rr6fum88gw
        case 'vViPmEMjeJm7bUQxhhonkZ': // WIRmachenDRUCK-940
            return WIRmachenDRUCK_1.WIRmachenDRUCK;
        default:
            return Cimpress_1.Cimpress;
    }
}
exports.getBranding = getBranding;
function getBrandingBasedOnFulfillerName(name) {
    const fulfillerName = (name || '').toLowerCase();
    const isWmd = fulfillerName.startsWith('wirmachendruck') || fulfillerName.startsWith('wmd');
    if (isWmd) {
        return WIRmachenDRUCK_1.WIRmachenDRUCK;
    }
    return Cimpress_1.Cimpress;
}
exports.getBrandingBasedOnFulfillerName = getBrandingBasedOnFulfillerName;
function getBrandingBasedOnMultipleFulfillerNames(names) {
    const fulfillerNames = names.map((name) => (name || '').toLowerCase());
    const isWmd = fulfillerNames
        .every((fulfillerName) => fulfillerName.startsWith('wirmachendruck')
        || fulfillerName.startsWith('wmd'));
    if (isWmd) {
        return WIRmachenDRUCK_1.WIRmachenDRUCK;
    }
    return Cimpress_1.Cimpress;
}
exports.getBrandingBasedOnMultipleFulfillerNames = getBrandingBasedOnMultipleFulfillerNames;
